import "../../../../src/pages/design/design-guidelines-styles.css";
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import * as React from 'react';
export default {
  LeadParagraph,
  React
};